import { addDays, format, startOfWeek } from "date-fns"
import { getDateFnsLocale } from "@/v2-common/utils/utils.date"
import DateRangePickerDay from "./DateRangePickerDay"

// Monday-first weekday abbreviations in the active locale ("Mo".."Su" /
// "ma.".."sø."). Monday start is forced so the header matches the day grid
// regardless of the locale's own first-day-of-week.
function getWeekdayLabels(): string[] {
  const locale = getDateFnsLocale()
  const monday = startOfWeek(new Date(), { weekStartsOn: 1 })
  return Array.from({ length: 7 }, (_, i) =>
    format(addDays(monday, i), "EEEEEE", { locale }),
  )
}

type DateRangePickerMonthProps = {
  monthKey: string
  date: Date
  weeks: (Date | null)[][]
}

function DateRangePickerMonth(props: DateRangePickerMonthProps) {
  const { monthKey, date, weeks } = props
  const weekdays = getWeekdayLabels()

  return (
    <div data-month={monthKey}>
      <div className="ui-date-picker-month-heading">
        <span>{format(date, "MMMM yyyy", { locale: getDateFnsLocale() })}</span>
      </div>

      <div className="ui-date-picker-weekdays">
        {weekdays.map((day) => (
          <span key={day} className="ui-date-picker-weekday">
            {day}
          </span>
        ))}
      </div>

      {weeks.map((week, wi) => (
        <div key={wi} className="ui-date-picker-week">
          {week.map((day, di) =>
            day ? (
              <DateRangePickerDay key={day.toISOString()} day={day} />
            ) : (
              <span key={`empty-${di}`} className="ui-date-picker-day-empty" />
            ),
          )}
        </div>
      ))}
    </div>
  )
}

export default DateRangePickerMonth
